import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { orderAPI } from '../../services/orderAPI';

interface OrderState {
  orders: any[];
  selectedOrder: any | null;
  totalOrders: number;
  currentPage: number;
  totalPages: number;
  isLoading: boolean;
  error: string | null;
}

const initialState: OrderState = {
  orders: [],
  selectedOrder: null,
  totalOrders: 0,
  currentPage: 1,
  totalPages: 0,
  isLoading: false,
  error: null,
};

export const fetchOrders = createAsyncThunk('orders/fetchOrders', async (params: { page?: number; limit?: number; status?: string }) => {
  return await orderAPI.getAllOrders(params);
});

export const fetchOrderDetails = createAsyncThunk('orders/fetchOrderDetails', async (id: string) => {
  return await orderAPI.getOrderById(id);
});

export const updateOrderStatus = createAsyncThunk('orders/updateOrderStatus', async ({ id, status }: { id: string; status: string }) => {
  return await orderAPI.updateOrderStatus(id, status);
});

const orderSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: { clearError: (state) => { state.error = null; } },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrders.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        console.log('Orders API response:', action.payload);
        state.orders = action.payload.data || action.payload.orders || [];
        state.totalOrders = action.payload.totalOrders || 0;
        state.currentPage = action.payload.currentPage || Number(action.payload.page) || 1;
        state.totalPages = action.payload.totalPages || action.payload.CurrentPages || 0;
        state.isLoading = false;
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || 'Failed to fetch orders';
      })
      .addCase(fetchOrderDetails.fulfilled, (state, action) => {
        state.selectedOrder = action.payload.data || action.payload.order || action.payload;
        state.isLoading = false;
      })
      .addCase(updateOrderStatus.fulfilled, (state, action) => {
        const updatedOrder = action.payload.data || action.payload;
        const index = state.orders.findIndex(o => o._id === updatedOrder._id);
        if (index !== -1) state.orders[index] = updatedOrder;
      });
  },
});

export default orderSlice.reducer;